import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as vars from "../../constants/constants";
import { show, hide } from "../../actions/ActivityIndicatorActions";
import { checkAccess } from "../../actions/WelcomeActions";
import axios from "axios";
import { Row, Col } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { config } from "../../constants/domainConfig";
import {
  getLogo,
  isAfricatv,
  isMobioplus,
  isVibe360,
  isCine360,
  isMundo360,
  getText,
} from "../../constants/multiDomains";
import { sendData } from "../../analytics/sendData";
import {
  isvalidNumber,
  getPlaceHolder,
  parse,
  getFlag,
} from "../../utils/loginUtils";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      msisdn: "",
      isValid: false,
      errorMessage: { id: "", defaultMessage: "" },
      domain: window.location.host,
      msisdnNotFound: false,
      reason: "",
    };
    this.onSubmit = this.onSubmit.bind(this);
    this.onChangeMsisdn = this.onChangeMsisdn.bind(this);
    this.onKeyUp = this.onKeyUp.bind(this);
    this.callAuthenticate = this.callAuthenticate.bind(this);
  }

  onChangeMsisdn(e) {
    if (this.state.errorMessage.id)
      this.setState({ errorMessage: { id: "", defaultMessage: "" } });
    this.setState({ msisdn: e.target.value });
  }

  onKeyUp(e) {
    if (e.keyCode == 13) {
      this.onSubmit(e);
    }
  }

  onSubmit(e) {
    e.preventDefault();
    if (isvalidNumber(this.state.msisdn, config.country)) {
      this.setState({ isValid: true, errorMessage: "" });
      const msisdn = parse(this.state.msisdn, config.country);
      this.callAuthenticate({
        msisdn: msisdn,
      });
    } else {
      if (!this.state.msisdn) {
        this.setState({
          isValid: false,
          msisdnNotFound: false,
          errorMessage: {
            id: "phone-number-required",
            defaultMessage: "Phone number is required.",
          },
        });
      } else {
        this.setState({
          msisdnNotFound: false,
          isValid: false,
          errorMessage: {
            id: "invalid-phone-number",
            defaultMessage: "Invalid phone number.",
          },
        });
      }
    }
  }

  callAuthenticate(data) {
    this.props.show();
    axios
      .get(
        vars.BASE_API_URL +
          `/checkAccessWithMsisdn?msisdn=${data.msisdn}&domain=${this.state.domain}`
      )
      .then((response) => {
        this.props.hide();
        if (response.data.success) {
          let data = {
            success: response.data.success,
            uid: response.data.data.uid,
            token: response.data.data.token,
            subscriptionInfo: response.data.data.payload,
          };
          sessionStorage.setItem("authorized", JSON.stringify(data));
          sendData("", "", "", "Accessed", {
            method: "msisdn",
            status: "success",
            rid: data.subscriptionInfo.rockmanId,
            url: window.location.href,
          });
          this.props.checkAccess(data);
          this.props.history.push("/category/vod/?uid=" + data.uid);
        } else {
          this.setState({
            msisdnNotFound: false,
            isValid: false,
            reason: response.data.data,
            errorMessage: {
              id: "sub_not_found",
              defaultMessage: "No subscription found",
            },
          });
          // this.props.history.push("/restricted");
        }
      })
      .catch((error) => {
        this.props.hide();
        console.log(error);
        this.setState({
          errorMessage: {
            id: "sub_not_found",
            defaultMessage: "No subscription found",
          },
        });
      });
  }

  render() {
    const flag_url = getFlag(config.country);
    return (
      <div className="login animated fadeIn">
        <Row className="justify-content-center">
          <Col>
            <Row className="login-page-header">
              <div className="login-page-header-child">
                <img
                  className="login-page-logo"
                  src={getLogo()}
                  alt="Mobio360"
                  width="125px"
                />
              </div>
            </Row>
            <Row className="login-page-content">
              <h1>
                <FormattedMessage
                  id={`areYou_${getText()}`}
                  defaultMessage={`Are you already a member of ${getText()}?`}
                />
              </h1>
              {/* <h1>
                {isAfricatv() ? (
                  <FormattedMessage
                    id="areYouAfricatv"
                    defaultMessage="Are you already a member of Africatv?"
                  />
                ) : isVibe360() ? (
                  <FormattedMessage
                    id="areYouVibe360"
                    defaultMessage="Are you already a member of vibe360?"
                  />
                ) : isCine360() ? (
                  <FormattedMessage
                    id="areYouCine360"
                    defaultMessage="Are you already a member of Cine360?"
                  />
                ) : isMobioplus() ? (
                  <FormattedMessage
                    id="isMobioplus"
                    defaultMessage="Are you already a member of Mobioplus?"
                  />
                ) : isMundo360() ? (
                  <FormattedMessage
                    id="isMundo360"
                    defaultMessage="Are you already a member of Mundo360?"
                  />
                ) : (
                  <FormattedMessage
                    id="areYou"
                    defaultMessage="Are you already a member of Mobio360?"
                  />
                )}
              </h1> */}
              <p>
                <FormattedMessage
                  id="thenConfirm"
                  defaultMessage="Then confirm your mobile number and get unlimited access to all our content"
                />
              </p>

              <div className="login-page-mobile_num">
                {flag_url ? (
                  <div className="flag_container">
                    <img
                      src={flag_url}
                      className={`flag_url ${
                        config.lang === "ar" ? "flag_url_rtl" : ""
                      }`}
                    />
                  </div>
                ) : null}
                <input
                  type="number"
                  placeholder={getPlaceHolder(config.country)}
                  autoFocus
                  name="msisdn"
                  maxLength="15"
                  value={this.state.msisdn}
                  onChange={this.onChangeMsisdn}
                  onKeyUp={this.onKeyUp}
                  className="LoginRoute-number"
                  style={flag_url ? { textIndent: "41px" } : {}}
                />
                <button
                  type="submit"
                  onClick={this.onSubmit}
                  className="LoginRoute-button"
                >
                  <FormattedMessage id="login" defaultMessage="Login" />
                  <i className="icon-back"></i>
                </button>
              </div>
              {!this.state.isValid && this.state.errorMessage.id ? (
                <span className="error-message">
                  <FormattedMessage
                    id={this.state.errorMessage.id}
                    defaultMessage={this.state.errorMessage.defaultMessage}
                  />
                </span>
              ) : null}
            </Row>
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.AuthenticationReducer,
    loader: state.ActivityIndicatorReducer,
    access: state.WelcomeReducer,
  };
};

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      checkAccess,
      show,
      hide,
    },
    dispatch
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.js